/*** IMPORTS FROM imports-loader ***/
var define = false;

import emitter from '../../mixin/emitter'

export default {
  name: 'UiFormRadio',

  mixins: [emitter],

  inheritAttrs: false,

  inject: {
    uiFormItem: {
      default: '',
    },
  },

  model: {
    prop: 'modelValue',
    event: 'input',
  },

  // language=HTML (for PhpStorm)
  template: `
    <div :class="[
      'form-check',
      { 
        'form-check-inline': inline,
        'is-disabled': disabled,
      }
    ]">
      <label class="form-check-label">
        <input
          v-bind="$attrs"
          class="form-check-input"
          type="radio"
          :disabled="disabled"
          :value="radioValue"
          :checked="isChecked"
          @change="handleChange"
        />
        <slot></slot>
        <template v-if="!$slots.default">{{ label }}</template>
      </label>
    </div>
  `,

  props: {
    disabled: Boolean,
    modelValue: {},
    value: {},
    label: {},
    inline: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {}
  },

  computed: {
    radioValue() {
      if (this.value !== undefined) {
        return this.value
      }
      return this.label
    },

    isChecked() {
      return this.modelValue === this.radioValue
    },
  },

  methods: {
    handleChange() {
      this.$emit('input', this.radioValue)
      this.dispatch('UiFormItem', 'ui.form.change', this.radioValue)
      this.$emit('change', this.radioValue)
    },
  },
}

